import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';

  Sentry.init({
    dsn: environment.sentry_project_dsn,
    environment: environment.sentry_env,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.routingInstrumentation,
      }),
    ],
    tracesSampleRate: 1.0,
    release:environment.version
  });

  enableProdMode();


platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
